export default function Footer() {
  return (
    <footer className="bg-radio-dark-blue/80 backdrop-blur-md border-t border-radio-blue/20 py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-gray-400">© 2025 Радио Саня by Nuvertal</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

